// https://github.com/jquense/yup
// Dead simple Object schema validation

import * as yup from "yup";

const descriptionMaxLength = 2000;
const specificationsMaxLength = 2000;

const descriptionSchemaShape = {
  description: yup
    .string()
    .max(descriptionMaxLength, `Description must be fewer than ${descriptionMaxLength} characters.`),
};

const specificationsSchemaShape = {
  specifications: yup
    .string()
    .max(specificationsMaxLength, `Specifications must be fewer than ${specificationsMaxLength} characters.`),
};

const productDescriptionYupSchema = yup.object().shape(descriptionSchemaShape);
const productSpecificationsYupSchema = yup.object().shape({
  subtype_attributes: yup.object().shape(specificationsSchemaShape),
});
const productYupSchema = yup.object().shape({
  ...descriptionSchemaShape,
  name: yup.string().required("Name is required."),
  headline_custom: yup.string().max(200, "Headline must be 200 characters or fewer."),
  price: yup
    .string()
    .test(
      "is-price-string",
      "Price must be a number representing the amount e.g. '79.99' or '129'",
      (value) => value === "" || value.replace(",", "").match(/^\d+(\.\d{2})?$/),
    ),
  subtype_attributes: yup.object().shape({
    ...specificationsSchemaShape,
  }),
});

export default productYupSchema;
export { descriptionMaxLength, specificationsMaxLength, productDescriptionYupSchema, productSpecificationsYupSchema };
